import { Pipe, PipeTransform } from '@angular/core';

export function sortCardsByDate<T extends Record<string, any>>(cards: T[], field: string = 'modifiedDate'): T[] {
  if (!Array.isArray(cards)) {
    return [];
  }

  return cards.sort((a, b) => {
    const dateA = new Date(a?.[field]).getTime();
    const dateB = new Date(b?.[field]).getTime();
    const safeDateA = Number.isNaN(dateA) ? 0 : dateA;
    const safeDateB = Number.isNaN(dateB) ? 0 : dateB;

    return safeDateB - safeDateA;
  });
}

@Pipe({
  name: 'sortByDate'
})
export class SortByDatePipe implements PipeTransform {

  transform(cards: any[], field: string = 'modifiedDate'): any[] {
    return sortCardsByDate(cards, field);
  }

}
